var React = require('react');

function Login (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.83333 15.4167L6.34375 13.8458L9.10625 11.0833H0.25V8.91667H9.10625L6.34375 6.15417L7.83333 4.58333L13.25 10L7.83333 15.4167ZM10 19.75V17.5833H17.5833V2.41667H10V0.25H17.5833C18.1792 0.25 18.6894 0.461972 19.1141 0.885917C19.538 1.31058 19.75 1.82083 19.75 2.41667V17.5833C19.75 18.1792 19.538 18.6894 19.1141 19.1141C18.6894 19.538 18.1792 19.75 17.5833 19.75H10Z","fill":"#73C6E3"}));
}

Login.defaultProps = {"width":"35","height":"35","viewBox":"0 0 20 20","fill":"none"};

module.exports = Login;

Login.default = Login;
